<template>
  <div
    v-if="isShowPage"
    class="edit-user"
  >
    <van-nav-bar
      v-if="isAgentInformation == 1"
      class="nav-edit"
      :right-text="userInfo.isPropertyAgent && agentBox ? lang.modify : ''"
      :title="lang.agentInformation"
      left-arrow
      @click-right="goModify"
      @click-left="onClickLeftAgent"
    />
    <van-nav-bar
      v-if="isAgentInformation == 2"
      class="nav-edit"
      :title="lang.deleteAccount"
      left-arrow
      @click-left="onClickLeftDelete"
    />
    <van-nav-bar
      v-if="isAgentInformation == 0"
      :title="lang.changeMemberProfile"
      :left-arrow="!$route.query.fromapp"
      @click-left="onClickLeft"
    />
    <div
      v-if="isAgentInformation == 0"
      class="user"
    >
      <!-- 用户基本资料 -->
      <div class="user-detail">
        <!-- 头像 -->
        <van-cell
          class="user-img"
          :title="lang.userPicture"
        >
          <img
            :src="userInfo.imagePath | imgResize('user')"
            onerror="errorImg(this,'user')"
            alt
            @click="editUserPic = true"
          >
          <van-icon name="arrow" />
        </van-cell>
        <!-- 设置密码 修改密码 -->
        <van-cell
          :class="{ 'no-password': !userInfo.isSetPassWord }"
          :title="lang.password"
          is-link
          :value="userInfo.isSetPassWord ? '********' : lang.setPassword"
          @click="userInfo.isSetPassWord ? goPage('edit-password') : goPage('set-password')"
        />
        <!-- 邮箱  -->
        <van-cell
          :class="{ 'no-password': !userInfo.email }"
          :title="lang.email"
          is-link
          :value="!userInfo.email ? lang.join : userInfo.email"
          @click="userInfo.email ? (editEmailNotice = true) : goPage('set-email')"
        />
        <!-- 手提电话 -->
        <van-cell
          :title="lang.cellPhone"
          is-link
          :value="userInfo.telephone"
          @click="goPage('edit-telephone')"
        />
        <!-- 用户名 -->
        <van-cell
          :title="lang.memberName"
          is-link
          :value="userInfo.nickName ? userInfo.nickName : ''"
          @click="editNameShow = true"
        />
        <!-- 隐藏接收通讯栏 -->
        <!-- <van-switch-cell @change="changeSwitch" class="switch-select" v-model="userInfo.isReceiveMessage" :title="lang.acceptInformation" active-color="#FF0000" /> -->
        <van-switch-cell
          v-model="userInfo.isReceiveSMS"
          class="switch-select"
          :title="lang.acceptSMS"
          active-color="#FF0000"
          @change="changeSwitch"
        />
      </div>
      <!-- 绑定第三方账户 -->
      <div 
        v-if="showGoogle || showFacebook || showApple"
        class="third-party" 
      >
        <div class="third-tit">{{lang.thirdloginType}}</div>
        <div 
          v-if="showGoogle"
          class="social-btn google-redirect-btn" 
          @click="bindWithRedirect"
        >
          <img 
            src="../assets/Google.png" 
            alt="" 
            class="social-icon social-icon-go"
          >
          <span class="bind-txt">{{ userInfo.googleEmail ? lang.alinked + '('+userInfo.googleEmail +')' :lang.link }}</span>
        </div>

        <div 
          v-if="showFacebook"
          class="social-btn facebook-redirect-btn" 
          @click="bindWithFacebookRedirect"
        >
          <img 
            src="../assets/Facebook.png" 
            alt="" 
            class="social-icon" 
          >
          <span class="bind-txt">{{ userInfo.faceBookEmail ? lang.alinked + '('+userInfo.faceBookEmail +')' :lang.link }}</span>
        </div>
        <!-- 只有一种情况不展示apple绑定 安卓+未绑定 -->
        <div 
          v-if="showApple"
          class="social-btn facebook-redirect-btn" 
          @click="handleAppleBind(3)"
        >
          <img 
            src="../assets/apple.png" 
            alt="" 
            class="social-icon" 
          >
          <!-- 安卓app内部 只可以解除绑定，不可以展示绑定 -->
          <span class="bind-txt"  v-if = "!(isAndroidApp && !userInfo.appleEmail)">{{ userInfo.appleEmail ? lang.alinked + '('+userInfo.appleEmail +')' :lang.link }}</span>
        </div>
      </div>
      <!-- 进入代理部分 -->
      <div class="agent">
        <van-cell
          :title="lang.estateAgent"
          active-color="#FF0000"
          is-link
          @click="isAgentClick()"
        />
      </div>
      <div
        class="delete-user"
        @click="deleteUser"
      >
        {{ lang.deleteAccount }}
      </div>
    </div>
    <!-- 代理部分 -->
    <div
      v-if="isAgentInformation == 1"
      class="agency"
    >
      <!-- 展示部分 -->
      <div
        v-if="agentBox"
        class="show-detail"
      >
        <!-- 代理人头像信息 -->
        <div class="user-card">
          <div class="user-pic">
            <img
              :src="userInfo.imagePath | imgResize('user')"
              onerror="errorImg(this,'user')"
              alt
            >
          </div>
          <div class="user-card-detail">
            <div class="user-name">
              {{ userInfo.nickName }}
            </div>
            <div class="company-name">
              {{ userInfo.companyNameCN }}
            </div>
            <div class="company-num">
              {{ userInfo.license }}
            </div>
          </div>
        </div>
        <!-- 代理人签名 -->
        <div
          v-if="userInfo.signature"
          class="user-license"
        >
          {{ userInfo.signature }}
        </div>
        <!-- 代理人公司信息 -->
        <div class="agent-detail">
          <van-cell
            :title="lang.realEstateAgency"
            size="large"
            :label="userInfo.companyNameCN"
          />
          <van-cell
            v-if="userInfo.companyNameEN"
            :title="lang.realEstateAgencyEN"
            size="large"
            :label="userInfo.companyNameEN"
          />
          <van-cell
            :title="lang.realEstateAgencyPhone"
            size="large"
            :label="userInfo.companyTelephone"
          />
          <van-cell
            v-if="userInfo.companyAddress"
            :title="lang.realEstateAgencyAddress"
            size="large"
            :label="userInfo.companyAddress"
          />
          <van-cell
            :title="lang.estateAgencyLicense"
            size="large"
            :label="userInfo.companyLicense"
          />
          <van-cell
            :title="lang.personalAstateAgencyLicense"
            size="large"
            :label="userInfo.license"
          />
          <van-cell
            class="company-img"
            center="true"
          >
            <template #title>
              <div class="custom-title">
                {{ lang.agentCard }}
              </div>
              <div class="company-tips">
                {{ lang.companyTips }}
              </div>
              <div class="company-tips">
                {{ lang.notice2 }}
              </div>
              <!-- <van-tag type="danger">标签</van-tag> -->
            </template>
            <img
              :src="userInfo.agentCardPath | imgResize('agent')"
              onerror="errorImg(this,'agent-company')"
              alt
            >
            <van-icon name="arrow" />
          </van-cell>
          <van-cell
            :title=" lang.agentCardTime"
            size="large"
            :label="agentInfo.agentCardExpireTime && agentInfo.agentCardExpireTime >0? new Date(parseInt(agentInfo.agentCardExpireTime ) * 1000).toLocaleDateString():''"
          />
        </div>
      </div>
      <!-- 修改部分 -->
      <div
        v-else
        class="edit-detail"
      >
        <!-- 代理公司名称 -->
        <div class="input-title">
          <span class="red">*</span>{{ lang.realEstateAgency }}
        </div>
        <!-- :disabled="userInfo.companyNameCN"  :disabled="userInfo.companyNameEN" -->
        <van-field
          v-model="agentInfo.companyNameCN"
          maxlength="50"
          :placeholder="lang.pleaseFillOut"
          :disabled="disabledTextCN"
        />
        <div class="input-title">
          <span class="red" />{{ lang.realEstateAgencyEN }}
        </div>
        <van-field
          v-model="agentInfo.companyNameEN"
          maxlength="100"
          :placeholder="lang.pleaseFillOut"
          :disabled="disabledTextEN"
        />
        <!-- 代理公司电话 -->
        <div class="input-title">
          <span class="red">*</span>{{ lang.realEstateAgencyPhone }}
        </div>
        <!-- :disabled="userInfo.companyTelephone" -->
        <van-field
          v-model="agentInfo.companyTelephone"
          maxlength="8"
          :placeholder="lang.pleaseFillOut"
          @input="checkInt('companyTelephone', 1)"
        />
        <!-- 代理公司地址 -->
        <!-- <span class="red">*</span> -->
        <div class="input-title">
          {{ lang.realEstateAgencyAddress }}
        </div>
        <!-- :disabled="userInfo.companyAddress" -->
        <van-field
          v-model="agentInfo.companyAddress"
          maxlength="50"
          :placeholder="lang.pleaseFillOut"
        />
        <!-- 代理签名 -->
        <div class="input-title">
          <span class="red">*</span>{{ lang.estateAgencyLicense }}
        </div>
        <!--  :disabled="userInfo.companyLicense" -->
        <van-field
          v-model="agentInfo.companyLicense"
          maxlength="20"
          :placeholder="lang.pleaseFillOut"
        />
        <!-- 个人签名 -->
        <div class="input-title">
          <span class="red">*</span>{{ lang.personalAstateAgencyLicense }}
        </div>
        <van-field
          v-model="agentInfo.license"
          :disabled="userInfo.license"
          maxlength="20"
          :placeholder="lang.pleaseFillOut"
        />
        <!-- 个人介绍备注 -->
        <div class="input-title">
          {{ lang.personalAgentSignature }}
        </div>
        <div class="textarea">
          <!-- :disabled="userInfo.signature" -->
          <textarea
            v-model="agentInfo.signature"
            maxlength="200"
            :placeholder="lang.enterNote"
          />
          <span class="textarea-num">200</span>
        </div>
        <div class="div-line" />
        <!-- 上传图片  -->
        <div class="agent-pic">
          <van-uploader
            :after-read="afterRead"
            :max-size="5242880"
            accept="image/jpeg,image/jpg,image/png"
            :disabled="userInfo.agentCardPath ? true : false"
            @oversize="oversize"
          >
            <van-cell center="true">
              <template #title>
                <div><span class="red">*</span>{{ lang.agentCard }}</div>
                <p
                  class="agent-notice"
                  style="margin-top: 4px;"
                >
                  {{ lang.notice }}
                </p>
                <p>{{ lang.notice1 }}</p>
                <p style="margin-top: 8px;">
                  {{ lang.notice2 }}
                </p>
              </template>
              <!-- @click="clickUploaderAgent" -->
              <div
                v-if="!agentInfo.agentCardPath"
                class="img-bg"
              />
              <img
                v-else
                :src="agentInfo.agentCardPath | imgResize('agent')"
                onerror="errorImg(this,'agent-company')"
                alt
              >
              <!-- 原生方法 -->
              <!-- <input type="file" id="up-agent-input" class="up-agent-input" accept="image/jpeg,image/jpg,image/png" @change="uploaderAgent($event)" /> -->
              <van-icon name="arrow" />
            </van-cell>
          </van-uploader>
        </div>
        <div class="div-line" />
        <div class="agent-time">
          <van-cell
            style="padding: 15px"
            @click="judgeTime"
          >
            <template slot="title">
              <div>
                <span class="red">*</span>
                <span style="font-size: 15px; color: #333333; line-height: 21px; display: inline-block">{{ lang.agentCardTime }}</span>
              </div>
              <div>
                <span :class="[{ fcolor:!agentInfo.agentCardExpireTime || agentInfo.agentCardExpireTime <0}]">{{ agentInfo.agentCardExpireTime && agentInfo.agentCardExpireTime >0? new Date(parseInt(agentInfo.agentCardExpireTime ) * 1000).toLocaleDateString():lang.pleSelect }}</span>
              </div>
            </template>
            <template slot="default">
              <div @click.stop>
                <van-popup
                  v-model="showPopup"
                  class="popup"
                  position="bottom"
                  :close-on-click-overlay="true"
                  @click-overlay="showPopup = false"
                >
                  <van-datetime-picker
                    v-model="agentCardExpireTime"
                    type="date"
                    :confirm-button-text="lang.confirm"
                    @confirm="confirmAgenTime"
                    @cancel="cancelAgenTime"
                  />
                </van-popup>
              </div>
              <div class="agentcontent">
                <van-icon
                  class="fcolor"
                  name="arrow"
                />
              </div>
            </template>
          </van-cell>
        </div>
        <div class="div-line" />
        <!-- 提交更改 -->
        <div class="btn-sub">
          <van-button
            :disabled="isClickEditAgent ? false : true"
            type="danger"
            size="large"
            @click="submitEdit"
          >
            {{ lang.submit }}
          </van-button>
        </div>
      </div>
    </div>
    <!-- 删除账户 -->
    <div
      v-if="isAgentInformation == 2"
      class="delete-page"
    >
      <div class="delete-page-title">
        {{ lang.deletePageTitle }}
      </div>
      <div class="delete-page-info">
        {{ lang.deletePageInfo1 }}
      </div>
      <div
        class="delete-page-info"
        style="margin-top: 24px;margin-bottom: 44px;"
      >
        {{ lang.deletePageInfo2 }}
      </div>
      <div
        class="confirm-delete"
        @click="confirmDelte"
      >
        {{ lang.deleteBtnText }}
      </div>
    </div>
    <!-- 上传图片预览剪切 -->
    <van-popup
      v-model="editUpPic"
      :overlay="false"
      class="edit-up-pic"
    >
      <van-nav-bar
        :title="lang.confirmPhoto"
        left-arrow
        @click-left="editUpPic = false"
      />
      <div class="avatar-cropper-container">
        <div class="width-height">
          <vueCropper
            ref="cropper"
            :fixed="true"
            :auto-crop="true"
            :img="file"
            :output-size="1"
            output-type="png"
          />
        </div>
      </div>
      <div class="btn-edit-pic">
        <van-button
          type="primary"
          class="cancel"
          @click="editUpPic = false"
        >
          {{ lang.cancel }}
        </van-button>
        <van-button
          type="primary"
          class="comfrim"
          @click="clickEditPic"
        >
          {{ lang.confirm1 }}
        </van-button>
      </div>
    </van-popup>
    <!-- 上传图片修改框 -->
    <van-popup
      v-model="editUserPic"
      position="bottom"
      class="edit-pic"
    >
      <!-- 上传图片限制 image/png, image/jpeg, image/jpg-->
      <!-- 原生上传图片测试 -->
      <!-- <div class="new-img-uploader">
        <van-button type="primary" @click="clickUploaderPicture" class="choose" block>
          {{ lang.choosePic }}
        </van-button>
        <input type="file" id="up-img-input" class="up-img-input" accept="image/jpeg,image/jpg,image/png" @change="uploaderPicture($event)" />
      </div> -->
      <!-- 上传图片 flutter -->
      <van-uploader
        class="uploader"
        :after-read="afterReadLocal"
        :max-size="5242880"
        accept="image/jpeg,image/jpg,image/png"
        @oversize="oversize"
      >
        <van-button
          type="primary"
          class="choose"
          block
        >
          {{ lang.choosePic }}
        </van-button>
      </van-uploader>
      <!-- 移除图片 -->
      <van-button
        type="primary"
        class="remove"
        block
        @click="clickRemovePic"
      >
        {{ lang.removePic }}
      </van-button>
      <van-button
        type="primary"
        class="cancel"
        block
        @click="editUserPic = false"
      >
        {{ lang.cancel }}
      </van-button>
    </van-popup>
    <van-dialog 
      v-model="appBindLoding" 
      :show-confirm-button="false" 
      class="login_case"
    >
      <div class="login_content">
        <div>
          <van-loading 
            class="loading" 
            color="#1989fa" 
            size="20px" 
            vertical 
          />
        </div>
      </div>
    </van-dialog>
    <!-- 弹出框 -->
    <van-dialog
      v-model="editNameShow"
      :confirm-button-text="lang.confirm1"
      :close-on-click-overlay="true"
      class="edit-user-name"
      :title="lang.editUserName"
      @confirm="editUserName"
    >
      <van-field
        v-model="editNameValue"
        maxlength="10"
        :placeholder="lang.editNameNoitce"
      />
      <!--  -->
    </van-dialog>
    <!-- 邮箱提示弹窗 -->
    <van-dialog
      v-model="editEmailNotice"
      :confirm-button-text="lang.confirm1"
      :close-on-click-overlay="true"
      class="edit-email-notice"
    >
      <p>{{ lang.editEmailNotice }}</p>
    </van-dialog>
  </div>
</template>
<script>
import pub from '../../common/public';
import { Cell, NavBar, List, Field, Notify, Uploader, Toast, Dialog } from 'vant';
import { mapState, mapMutations } from 'vuex';
import { VueCropper } from 'vue-cropper';
import lang from './../../common/language/editUser';
const FACEBOOK_API_VERSION = 'v20.0';
export default {
  name: 'EditUser',
  components: {
    VueCropper,
  },
  data() {
    return {
      showGoogle: false,
      showFacebook: false,
      showApple: false,
      isSubmitting: false,
      isIos:false,
      isAndroidApp:false,
      appBindLoding:false,
      isThirdPartyLogging:false,
      googleClientId: '',
      facebookAppId: '',
      appleClientId: '',
      disabledTextCN: false,
      disabledTextEN: false,
      isFirstTime:false,
      agentCardExpireTime: new Date(new Date().getFullYear(), 0, 1),
      showPopup:false,
      numFlag: 0,
      deleteFlag: false,
      isShowPage: false,
      isPc: false,
      fromapp: '',
      file: '',
      fileName: '',
      editUpPic: false,
      editEmailNotice: false,
      isClickEditAgent: false,
      isShowEditAgent: false,
      editNameValue: '',
      editNameShow: false,
      editUserPic: false,
      cacheNum: '',
      lang: lang,
      isShowEdit: true,
      userInfo: {},
      agentInfo: {
        companyNameCN: '',
        companyNameEN: '',
        companyTelephone: '',
        companyAddress: '',
        companyLicense: '',
        license: '',
        signature: '',
        agentCardPath: '',
        agentCardExpireTime:'',
      },
      agentBox: false,
      isAgentInformation: 0,
      activeThirdType: null,      // 记录当前正在呼叫原生的第三方类型(1:Google, 2:FB)
    };
  },
  watch: {
    agentInfo: {
      handler(val) {
        if (val.companyNameCN && val.companyTelephone && val.companyLicense && val.license && val.agentCardPath && val.agentCardExpireTime && val.agentCardExpireTime >0) {this.isClickEditAgent = true;}
        else {this.isClickEditAgent = false;}
      },

      deep: true,
    },
  },
  created() {
    // 1. 判断是否为 iOS
    const ua = navigator.userAgent;
    const isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1;
    const isFlutter = navigator.userAgent.indexOf('flutter') > -1;
    const inApp = this.isInsideApp();
    // 3. 精准判定：在安卓 App 内部
    this.isAndroidApp = isAndroid && inApp;
    this.isIos = !(isAndroid || isFlutter)
    // this.isAndroidApp = isAndroid && isFlutter;
    this.isPc = !(document.body.clientWidth <= 750 || /mobi|android|iphone|blackberry|ipod|iemobile/i.test(navigator.userAgent.toLocaleLowerCase()))
    if (this.isPc) {
      if (this.isAgentInformation == 0) {
        if (pub.getLang() === 'zh-cn') {
          location.href = `${pub.config.pcPassport}zh-cn/changeuserinfo/`;
        } else if (pub.getLang() === 'en-us') {
          location.href = `${pub.config.pcPassport}en-us/changeuserinfo/`;
        } else {
          location.href = `${pub.config.pcPassport}changeuserinfo/`;
        }
      } else if (this.isAgentInformation == 1) {
        if (pub.getLang() === 'zh-cn') {
          location.href = `${pub.config.pcPassport}zh-cn/changeagentinfo/`;
        } else if (pub.getLang() === 'en-us') {
          location.href = `${pub.config.pcPassport}en-us/changeagentinfo/`;
        } else {
          location.href = `${pub.config.pcPassport}changeagentinfo/`;
        }
      }
    } else {
      this.isShowPage = true;
    }
    this.getUserInfo();
    this.getConfig()
    if (this.$route.query.fromapp) {this.fromapp = this.$route.query.fromapp;}
  },
  async mounted() {
    this.initNativeChannel();
    // 重定向回调token解析
    this.checkGoogleRedirectCallback();
    this.checkFacebookRedirectCallback();
    this.checkAppleRedirectBindCallback();
    // 动态获取client id
    await this.fetchOauthConfig('GoogleClientId');
    await this.fetchOauthConfig('FacebookClientId');
    await this.fetchOauthConfig('AppleClientId');
    // console.log("agentinfo:",this.agentInfo,"userinfo:",this.userInfo)
  },
  beforeDestroy() {
    // 🌟 新增：离开页面时清理通道，防止内存泄漏
    delete window['onThirdPartyAuthChannel'];
  },
  methods: {
    async getConfig(){
      try {
        const res = await this.axios.get(this.pub.getApi().GetWapConfig + '?key=ThirdRegistration');
        const resultStr = res.data.result || ''; 
        // 使用 includes 进行简单判断
        this.showGoogle = resultStr.includes('Google');
        this.showFacebook = resultStr.includes('Facebook');
        this.showApple = resultStr.includes('Apple');
      } catch (error) {
        console.error('获取配置失败:', error);
      }
    },
    // 🌟 抽离出来的全局原生回调通道
    initNativeChannel() {
      console.log('初始化原生回调通道');
      window['onThirdPartyAuthChannel'] = async (base64Str) => {
        this.appBindLoding = true

        try {
          const decodedUriStr = window.atob(base64Str);
          const jsonStr = decodeURIComponent(decodedUriStr);
          const nativeResponse = JSON.parse(jsonStr);

          if (nativeResponse && nativeResponse.idToken) {
            // 注意这里使用的是 data 里保存的 activeThirdType
            await this.bindAccountWithThird(nativeResponse.idToken, this.activeThirdType);
          } else {
            if (this.$toast) {this.$toast.clear(); this.$toast.fail('用户取消绑定'); }
          }
        } catch (parseError) {
          if (this.$toast) { this.$toast.clear();this.$toast.fail('数据解析失败'); }
        } finally{
          this.appBindLoding = false;
        }
      };
    },
    // 1. Apple 绑定/解绑
    async handleAppleBind(thirdType = 3) {
      if (this.isAndroidApp && !this.userInfo.appleEmail) {
        return;
      }
      if (this.isSubmitting) {return;}
      this.isSubmitting = true;

      try {
        if (this.userInfo.appleEmail) {
          // 解绑逻辑（必须 await，确保执行完才走 finally）
          await this.UnBindAccountWithThird(thirdType);
        } else {
          if (this.isInsideApp()) {
            // App 内 → 走原生流
            await this.bindThirdPartyWithApp(thirdType);
          } else {
            // 浏览器 → 走重定向流
            this.loginWithAppleRedirect();
            return; // 页面即将跳转，不走 finally 解锁
          }
        }
      } catch (error) {
        console.error('Apple 绑定/解绑异常:', error);
      } finally {
        // 统一 1.5 秒后解锁，防止连续点击
        setTimeout(() => {
          this.isSubmitting = false;
        }, 1500);
      }
    },
    // 🌟 浏览器端 Apple 重定向绑定
    loginWithAppleRedirect() {
      const state = this.generateRandomString();
      sessionStorage.setItem('apple_oauth_state_bind', state);

      const redirectUri = this.getRedirectUri();
      const params = new URLSearchParams({
        client_id: this.appleClientId,
        redirect_uri: redirectUri,
        response_type: 'code id_token',
        response_mode: 'fragment',
        state: state,
      });

      window.location.href = `https://appleid.apple.com/auth/authorize?${params.toString()}`;
    },
    // 🌟 Apple 重定向回调处理（绑定场景）
    async checkAppleRedirectBindCallback() {
      console.log('--- 检测 Apple 绑定回调 ---');
      const hash = window.location.hash;
      const savedState = sessionStorage.getItem('apple_oauth_state_bind');

      if (!hash || !hash.includes('id_token') || !savedState) {
        return;
      }

      let isAppleCallback = false;

      try {
        const hashParams = new URLSearchParams(hash.substring(1));
        const idToken = hashParams.get('id_token');
        const state = hashParams.get('state');

        if (!state || state !== savedState) {
          return;
        }

        isAppleCallback = true;
        sessionStorage.removeItem('apple_oauth_state_bind');

        this.$toast.loading({ message: '', forbidClick: true, duration: 0 });

        if (idToken) {
          await this.bindAccountWithThird(idToken, 3);
        }
      } catch (error) {
        console.error('Apple 绑定回调处理异常:', error);
      } finally {
        if (this.$toast) { this.$toast.clear(); }
        if (isAppleCallback) {
          console.log('apple绑定回调清理了hash', window.location.hash);
          window.location.hash = '';
        }
      }
    },
    // 🌟 修改后的唤起方法
    async bindThirdPartyWithApp(thirdType) {
      this.activeThirdType = thirdType;

      try {
        const hasFlutterOrAndroid = !!(window.house730 && window.house730.postMessage);
        const hasIosChannel = !!(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.onThirdPartyAuthResult);
        
        if (hasIosChannel || hasFlutterOrAndroid) {
          const isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1;
          const isFlutter = navigator.userAgent.indexOf('flutter') > -1;

          const payload = { 
            type: 'onThirdPartyAuthResult', 
            data: { thirdType: thirdType }
          };

          if (isFlutter) {
            window.house730.postMessage(JSON.stringify(payload));
          } else if (isAndroid) {
            const androidStr = JSON.stringify(payload);
            if (window.house730 && typeof window.house730.onThirdPartyAuthResult === 'function') {
              window.house730.onThirdPartyAuthResult(androidStr);
            } else if (typeof window.onThirdPartyAuthResult === 'function') {
              window.onThirdPartyAuthResult(androidStr); 
            } else {
              console.error('💥 Android 环境异常');
            }
          } else {
            if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.onThirdPartyAuthResult) {
              window.webkit.messageHandlers.onThirdPartyAuthResult.postMessage(payload);
            }
          }
        } else {
          throw new Error('未检测到 App 核心通道');
        }
      } catch (error) {
        if (this.$toast) {this.$toast.clear();this.$toast.fail('唤起 App 失败');}
      }
    },

    // 🌟 新增：判断当前是否在 App 内嵌 WebView 环境
    isInsideApp() {
      // 完美利用你们原有的 UA 暗号和老通道双重保险
      // const isFlutterUA = navigator.userAgent.toLowerCase().includes('flutter');
      const hasHouse730Channel = !!(window.house730 && window.house730.postMessage);
      const hasIosChannel = !!(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.onThirdPartyAuthResult);
      
      return hasHouse730Channel || hasIosChannel;
    },
    async fetchOauthConfig(id) {
      try {
        // 假设这是你的后端接口
        const res = await this.axios.get(this.pub.getApi().GetWapConfig + `?key=${id}`);
        if (res && res.data.code === 0 && res.data.result) {
          if (id == 'GoogleClientId') {
            this.googleClientId = res.data.result;
          }else if(id == 'FacebookClientId'){
            this.facebookAppId = res.data.result;
          }else if(id == 'AppleClientId'){
            this.appleClientId = res.data.result;
          }
        }
      } catch (error) {
        console.error(`动态获取三方配置失败 [${id}]:`, error);
      }
    },
    async bindWithFacebookRedirect() {
      if (this.isSubmitting) {return;}
      this.isSubmitting = true;

      try {
        if(this.userInfo.faceBookEmail){
            // 去解绑
           await this.UnBindAccountWithThird(2)
        }else{
          
          if (this.isInsideApp()) {
            this.bindThirdPartyWithApp(2); // Facebook 传 2
            setTimeout(() => { this.isSubmitting = false; }, 1500);
            return;
          }
          const state = this.generateRandomString();
          sessionStorage.setItem('facebook_oauth_state', state);
    
          const redirectUri = this.getRedirectUri(); // 你的登录页：https://.../my/login
          const params = new URLSearchParams({
            client_id: this.facebookAppId,
            // client_id: FACEBOOK_APP_ID,
            redirect_uri: redirectUri,
            response_type: 'token', // 隐式授权流，直接返回 token
            scope: 'email,public_profile',
            state: state,
          });
          window.location.href = `https://www.facebook.com/${FACEBOOK_API_VERSION}/dialog/oauth?${params.toString()}`;
  
        }
      } catch (error) {
        
      } finally {
        setTimeout(() => {
          this.isSubmitting = false;
        }, 1500);
      }
    },

    async bindWithRedirect(provider) {

      if (this.isSubmitting) {return;}
      this.isSubmitting = true;

      try {
        if(this.userInfo.googleEmail){
          // 去解绑
          await this.UnBindAccountWithThird(1)
        }else{
          // 如果检测到是在 App 内，直接拦截并调用 App 原生流
          if (this.isInsideApp()) {
            this.bindThirdPartyWithApp(1); // Google 传 1
            setTimeout(() => { this.isSubmitting = false; }, 1500);
            return;
          }
          // 生成 state 和 nonce 防攻击
          const state = this.generateRandomString();
          const nonce = this.generateRandomString();
          sessionStorage.setItem('oauth_state', state);
          sessionStorage.setItem('oauth_nonce', nonce);
    
          const redirectUri =  this.getRedirectUri();
          const params = new URLSearchParams({
            client_id: this.googleClientId,
            // client_id:GOOGLE_CLIENT_ID,
            redirect_uri: redirectUri,
            response_type: 'id_token',
            scope: 'openid profile email',
            state: state,
            nonce: nonce,
          });
    
          // 跳转到 Google 授权页面
          window.location.href =
            `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
        }
      } catch (error) {
        
      } finally{
        setTimeout(() => {
          this.isSubmitting = false;
        }, 1500);
      }

    },
    getRedirectUri() {
      const origin = window.location.origin;
      const language = window._language === 'zh-hk' ? '' : `${window._language}/`;
      return `${origin}/my/${language}edit-user/`;
    },
    async checkGoogleRedirectCallback() {
      console.log("--- 检测 Google 回调 ---");
      // Google 返回的参数也在 # 后面（例如：#id_token=xxx&state=xxx）
      const hash = window.location.hash;
      const savedState = sessionStorage.getItem('oauth_state');
      if (!hash || !hash.includes('id_token') || !savedState) { return; }

      try {
        // this.isThirdPartyLogging = true;
        // 1. 解析 Hash 参数
        const hashParams = new URLSearchParams(hash.substring(1));
        const idToken = hashParams.get('id_token');
        const state = hashParams.get('state');

        // 2. 校验 state 安全性，防止 CSRF 攻击
        const savedState = sessionStorage.getItem('oauth_state');
        if (!state || state !== savedState) {
          this.isThirdPartyLogging = false;
          return;
        }
        // 校验成功后及时清除
        sessionStorage.removeItem('oauth_state');
        sessionStorage.removeItem('oauth_nonce'); // 如果存了 nonce 一并清除

        if (idToken) {
          // 3. 调用后端核心接口传递给服务器，注意：Google 的 thirdType 传 1
          await this.bindAccountWithThird(idToken, 1);
        }
      } catch (error) {
        this.isThirdPartyLogging = false;
      } finally {
        // 清理掉 URL 中的 hash 碎片，保持地址栏干净
        window.location.hash = '';
        this.isThirdPartyLogging = false;

      }
    },

    // ===== 检查并处理 Facebook 回调的 Token =====
    async checkFacebookRedirectCallback() {
      console.log("--- 检测 Facebook 回调 ---");
      // Facebook 的隐式模式返回的参数在 # 后面（例如：#access_token=xxx&state=xxx）
      const hash = window.location.hash;
      const savedState = sessionStorage.getItem('facebook_oauth_state');
      if (!hash || !hash.includes('access_token') || !savedState) { return; }

      try {
        // this.isThirdPartyLogging = true;
        // 1. 解析 Hash 参数
        const hashParams = new URLSearchParams(hash.substring(1));
        const accessToken = hashParams.get('access_token');
        const state = hashParams.get('state');
        // 2. 校验 state 安全性，防止 CSRF 攻击
        const savedState = sessionStorage.getItem('facebook_oauth_state');
        if (!state || state !== savedState) {
          this.isThirdPartyLogging = false;
          return;
        }
        // 校验成功后及时清除
        sessionStorage.removeItem('facebook_oauth_state');

        if (accessToken) {
          // 3. 调用后端核心接口传递给服务器，注意：Facebook 的 thirdType 传 2
          await this.bindAccountWithThird(accessToken, 2);
        }
      } catch (error) {
        this.isThirdPartyLogging = false;
      } finally {
        // 清理掉 URL 中的 hash 碎片，保持地址栏干净
        window.location.hash = '';
        this.isThirdPartyLogging = false;

      }
    },
        // 绑定第三方
    //  BindThirdAccount: `${baseUrl}ThirdOAuth/BindThirdAccount`, //登录用户绑定第三方账户
    // UnbindThirdAccount: `${baseUrl}ThirdOAuth/UnbindThirdAccount`, //登录用户解绑第三方账户
    async bindAccountWithThird(idToken, thirdType) {
      console.log('第三方绑定核心接口调用',);
      try {
        // 获取设备码（可从 localStorage 或设备信息获取）
        const res = await this.axios.post (this.pub.getApi().BindThirdAccount,{
        "IdToken":idToken,
        "thirdType":thirdType,
      });
      // 🌟 1. 只要接口响应回来了，第一时间清除全局的 loading Toast
      if (this.$toast) {
        this.$toast.clear();
      }
        if (res.data.code === 0) {
          this.getUserInfo();
          // if (this.$toast) {this.$toast.success('绑定成功');}
          // 重新获取用户信息
        } else {
          // 
          if(res.data.code == 1341){
              Dialog.confirm({
                className: 'custom-dia-style',
                title: lang.accountBind,
                message:lang.accountBindCon,
                showCancelButton:false,
                confirmButtonText: lang.confirm
              })
          }else if(res.data.code == 1342){
            Dialog.confirm({
              className: 'custom-dia-style',
              title: this.lang.bindInfo,
              message:this.lang.bindInfoCon,
              showCancelButton:false,
              confirmButtonText: this.lang.confirm
            })
          }else{
            Dialog.confirm({
              className: 'custom-dia-style',
              title: '',
              message: res.data.message,
              showCancelButton:false,
              confirmButtonText: this.lang.confirm
            }).then(() => {
              // 點擊確認按鈕後的邏輯
              console.log('用戶點擊了確認關閉1');
            })
            .catch((err) => {
              // 異常處理（比如點擊遮罩關閉）
              console.log('彈窗關閉catc1h',err);
            });
          
          }
        }
      } catch (error) {
        console.error('第三方绑定失败:', error);
        
      }
    },
    // 第三方账户解绑
    async UnBindAccountWithThird(thirdType) {
      if(!this.userInfo.telephone || this.userInfo.telephone == '' || !this.userInfo.isSetPassWord){
        Dialog.confirm({
          className: 'custom-dia-style',
          title: this.lang.bindInfo,
          message: this.lang.bindInfoCon,
          showCancelButton:false,
          confirmButtonText: lang.confirm
        })
      }else{
        Dialog.confirm({
          className: 'custom-dia-style',
            title: this.lang.linkCancel,
            message:this.lang.linkCancelCon,
            cancelButtonText: lang.cancel,
            confirmButtonText: lang.confirm
          })
          .then(async() => {
            try {
              // 获取设备码（可从 localStorage 或设备信息获取）
              const res = await this.axios.post (this.pub.getApi().UnbindThirdAccount,{
              "thirdType":thirdType,
              });
              if (res.data.code === 0) {
                this.getUserInfo();
              } else {
                // 填入手机号
                if(res.data.code == 1342){
                  Dialog.confirm({
                    className: 'custom-dia-style',
                    title: this.lang.bindInfo,
                    message: this.lang.bindInfoCon,
                    showCancelButton:false,
                    confirmButtonText: lang.confirm
                  })
                }else{
                  Dialog.confirm({
                    className: 'custom-dia-style',
                    title: '',
                    message: res.data.message,
                    showCancelButton:false,
                    confirmButtonText: lang.confirm
                  })
                }
                // 处理业务错误码 
              }
            } catch (error) {
              console.error('第三方解绑失败:', error);
            }
          });
      }
    },
    generateRandomString() {
      return Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15);
    },
    judgeTime(){
      if(this.isFirstTime){
      // if(this.agentInfo.agentCardExpireTime>0){
        return
      }
        this.showPopup=true

    },
    cancelAgenTime(){
      this.showPopup = false
    },
    confirmAgenTime(value){
      this.showPopup = false
      this.agentInfo.agentCardExpireTime = parseInt(value.getTime() / 1000)+86399;
    },
    /**上传图片事件 */
    clickUploaderPicture() {
      document.querySelector('#up-img-input').click();
    },
    /**上传头像剪切 */
    uploaderPicture(e) {
      if (!e.target.files) {
        e.target.value = null;
        return;
      }
      let file = e.target.files[0];
      if (file.size && file.size < 20480) {
        e.target.value = null;
        this.editUserPic = false;
        this.$notify(lang.fileBig2);
        return;
      }
      if (!file.size || file.size > 5242880) {
        e.target.value = null;
        this.editUserPic = false;
        this.$notify(lang.fileBig);
        return;
      }
      this.fileName = file.name;
      this.file = URL.createObjectURL(file);
      if (this.validateFile(file)) {
        this.editUpPic = true;
        this.editUserPic = false;
      } else {
        this.editUserPic = false;
        this.$notify(lang.fileError);
      }
      /**清空 触发事件 */
      e.target.value = null;
    },
    /**上传代理证书 */
    clickUploaderAgent() {
      document.querySelector('#up-agent-input').click();
    },
    uploaderAgent(e) {
      if (!e.target.files) {
        e.target.value = null;
        return;
      }
      let file = e.target.files[0];
      if (file.size && file.size < 20480) {
        e.target.value = null;
        this.$notify(lang.fileBig2);
        return;
      }
      if (!file.size || file.size > 5242880) {
        e.target.value = null;
        this.$notify(lang.fileBig);
        return;
      }
      let formData = new FormData();
      formData.append('file', file);
      if (this.validateFile(file)) {
        /**上传代理证 图片 */
        this.axios
          .post(this.pub.getApi().Upload, formData)
          .then((res) => {
            if (res.data.code === 0 && res.data.result) {
              this.agentInfo.agentCardPath = res.data.result[0].url;
            } else {
              this.$notify(lang.picfailure);
            }
          })
          .catch(() => {
            /**上传失败 */
            this.$notify(lang.picfailure);
          });
      } else {
        this.$notify(lang.fileError);
      }
      /**清空 触发事件 */
      e.target.value = null;
    },
    /**跳转页面 */
    goPage(data) {
      if (this.fromapp) {this.$router.push(`/${data}/?fromapp=${this.fromapp}`);}
      else {this.$router.push(`/${data}/`);}
    },
    /**剪切成功后上传 */
    clickEditPic() {
      this.$refs.cropper.getCropBlob((data) => {
        const file = new Blob([data], { type: data.type });
        const formdata = new FormData();
        formdata.append('file', file, this.fileName);
        /**上传图片 */
        this.axios
          .post(this.pub.getApi().Upload, formdata)
          .then((res) => {
            if (res.data.code === 0 && res.data.result) {
              /**直接修改头像 */
              this.axios
                .post(this.pub.getApi().UpdateUser, {
                  imagePath: res.data.result[0].url,
                })
                .then((resdata) => {
                  /**修改成功 */
                  if (resdata.data.code == 0) {
                    this.userInfo.imagePath = res.data.result[0].url;
                    this.editUserPic = false;
                    this.editUpPic = false;
                  } else {
                    this.$notify(lang.editFailure);
                  }
                });
            } else {
              this.$notify(lang.picfailure);
            }
          })
          .catch((e) => {
            this.$notify(lang.picfailure);
          });
      });
    },
    /**本地获取浏览图片 */
    afterReadLocal(file) {
      /**限制图片大小 */
      if (file.file.size && file.file.size < 20480) {
        this.editUserPic = false;
        this.$notify(lang.fileBig2);
        return;
      }
      this.fileName = file.file.name;
      this.file = URL.createObjectURL(file.file);
      if (this.validateFile(file.file)) {
        this.editUpPic = true;
        this.editUserPic = false;
      } else {
        this.editUserPic = false;
        this.$notify(lang.fileError);
      }
    },
    //验证头像格式
    validateFile(file) {
      const isJpg = file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png';
      return isJpg;
    },
    /**获取用户信息 */
    getUserInfo() {
      /**获取个人信息 */
      this.axios.get(this.pub.getApi().GetUserInfo).then((res) => {
        if (res.data.code == 0 && res.data.result) {
          this.userInfo = res.data.result;
          this.agentBox = res.data.result.isPropertyAgent;
          this.agentInfo.isPropertyAgent = res.data.result.isPropertyAgent;
          this.agentInfo.companyNameCN = res.data.result.companyNameCN;
          this.agentInfo.companyNameEN = res.data.result.companyNameEN;
          this.agentInfo.companyTelephone = res.data.result.companyTelephone;
          this.agentInfo.companyAddress = res.data.result.companyAddress;
          this.agentInfo.companyLicense = res.data.result.companyLicense;
          this.agentInfo.license = res.data.result.license;
          this.agentInfo.signature = res.data.result.signature;
          this.agentInfo.agentCardPath = res.data.result.agentCardPath || '';
          this.agentInfo.agentCardExpireTime =res.data.result.agentCardExpireTime || '';
          if (this.agentInfo.companyNameCN && this.agentInfo.companyNameCN.length > 0) {
            this.disabledTextCN = true
          } else {
            this.disabledTextCN = false
          }
          if (this.agentInfo.companyNameEN && this.agentInfo.companyNameEN.length > 0) {
            this.disabledTextEN = true
          } else {
            this.disabledTextEN = false
          }
          if( this.agentInfo.agentCardExpireTime && this.agentInfo.agentCardExpireTime>0){
            this.agentCardExpireTime = new Date(new Date(parseInt(this.agentInfo.agentCardExpireTime) * 1000).toLocaleDateString());
            this.isFirstTime = true
          }
        } else if (res.data.code == 101 || res.data.code == 100) {
          this.pub.delCookie('ERnJaMWtkM');
          this.pub.delCookie('cEVaUDFrZ1kd0RA');
          /**跳转页面 */
          if (navigator.userAgent.indexOf('house730') > -1) {
            let isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1; //android终端
            const isFlutter = navigator.userAgent.indexOf('flutter') > -1;
            if (isFlutter) {
              window.house730.postMessage(JSON.stringify({ type: 'jumpLogin', data: {} }));
            } else if (isAndroid) {
              window.house730.jumpLogin();
            } else {
              window.webkit.messageHandlers.jumpLogin.postMessage(JSON.stringify({}));
            }
          } else {
            // this.$router.push('/login/');
            // 第三方登录回调依赖固定的域名 所以改为该方式跳转登录
            let url = pub.getLang() === 'zh-cn' ? 'zh-cn/' : pub.getLang() === 'en-us' ? 'en-us/' : '';
            location.href = this.pub.config.pcUrl+'my/' + url +'login/?tab=1';
          }
        }
      });
    },
    /**打開修改代理人資料 */
    goModify() {
      this.agentBox = false;
    },
    /**修改用户名 */
    editUserName() {
      /**去掉空格 验证用户名格式 */
      this.editNameValue = this.editNameValue.trim();
      if (!this.editNameValue) {return;}
      if (!/^[a-zA-Z0-9\u4e00-\u9fa5]+$/.test(this.editNameValue)) {
        this.$notify(lang.editNameNoitce);
        this.editNameValue = '';
        return;
      }
      /**正则验证输入字符 */
      this.axios
        .post(this.pub.getApi().UpdateUser, {
          nickName: this.editNameValue,
        })
        .then((resdata) => {
          if (resdata.data.code == 0) {
            this.userInfo.nickName = this.editNameValue;
          } else {
            this.$notify(lang.editFailure);
          }
        });
    },
    /**点击移除相册按钮 */
    clickRemovePic() {
      this.editUserPic = false;
      Dialog.confirm({
        title: lang.removePicTitle,
        message: lang.isConfirm,
        confirmButtonColor: '#F73343',
        confirmButtonText: lang.confirm1,
        cancelButtonColor: '#333',
        cancelButtonText: lang.cancel,
      })
        .then(() => {
          /**修改头像 */
          this.axios
            .post(this.pub.getApi().UpdateUser, {
              imagePath: '',
            })
            .then((resdata) => {
              if (resdata.data.code == 0) {
                this.userInfo.imagePath = '';
              } else {
                this.$notify(lang.editFailure);
              }
            });
        })
        .catch();
    },
    /**改变Switch按钮 修改获得SMS 和 邮件 */
    changeSwitch() {
      let endName = '';
      if (this.editNameValue) {
        endName = this.editNameValue;
      } else if (this.userInfo.nickName) {
        endName = this.userInfo.nickName;
      }
      this.axios
        .post(this.pub.getApi().UpdateUser, {
          // nickName: this.editNameValue,
          nickName: endName,
          isReceiveSMS: this.userInfo.isReceiveSMS,
          isReceiveMessage: this.userInfo.isReceiveMessage,
        })
        .then((resdata) => {
          if (resdata.data.code == 0) {
          } else {
            this.$notify(lang.editFailure);
          }
        });
    },
    /**上传代理证 */
    afterRead(file) {
      if (file.file.size && file.file.size < 20480) {
        this.$notify(lang.fileBig2);
        return;
      }
      let formData = new FormData();
      formData.append('file', file.file);
      if (!this.validateFile(file.file)) {
        this.$notify(lang.fileError);
        return;
      }
      this.axios
        .post(this.pub.getApi().Upload, formData)
        .then((res) => {
          if (res.data.code === 0 && res.data.result) {
            this.agentInfo.agentCardPath = res.data.result[0].url;
          } else {
            this.$notify(lang.picfailure);
          }
        })
        .catch((e) => {
          /**上传失败 */
          this.$notify(lang.picfailure);
        });
    },
    /**oversize 上传图片超出大小*/
    oversize(file) {
      if (!file.file.name.toLocaleLowerCase().match(/(.*)\.(jpg|jpeg|png)$/)) {
        /**格式错误 */
        this.editUserPic = false;
        this.$notify(lang.fileError);
      } else {
        /**图片过大 */
        this.editUserPic = false;
        this.$notify(lang.fileBig);
      }
    },
    /**后退 */
    onClickLeft() {
      this.$router.go(-1);
    },
    /**提交更改 修改代理资料 */
    submitEdit() {
      /**验证 */
      /**手机号格式错误*/
      if (this.agentInfo.companyTelephone.length !== 8 || this.agentInfo.companyTelephone[0] == 0 || this.agentInfo.companyTelephone[0] == 1) {
        Notify(lang.telError);
        return;
      }
      /**修改参数 */
      this.agentInfo.isPropertyAgent = true;
      /**修改资料请求 */
      this.axios
        .post(this.pub.getApi().UpdateUser, this.agentInfo)
        .then((res) => {
          if (res.data.code == 0) {
            this.getUserInfo();
          }
        })
        .catch((e) => {
          this.$notify(lang.editFailure);
        });
    },
    //检测数字
    checkInt(field, type) {
      const num = this.agentInfo[field];
      /^$|^\d+$/.test(num) ? (this.cacheNum = num) : (this.agentInfo[field] = this.cacheNum);
    },
    /**关闭地產代理資料*/
    onClickLeftAgent() {
      if (this.userInfo.isPropertyAgent && !this.agentBox) {this.agentBox = true;}
      else if (this.userInfo.isPropertyAgent && this.agentBox) {this.isAgentInformation = 0;}
      else if (!this.userInfo.isPropertyAgent && !this.agentBox) {this.isAgentInformation = 0;}
    },
    // 关闭删除账户
    onClickLeftDelete() {
      this.isAgentInformation = 0;
    },
    /**打开地产代理资料 */
    isAgentClick() {
      this.isAgentInformation = 1;
      if (this.isPc) {
        if (this.isAgentInformation == 1) {
          if (pub.getLang() === 'zh-cn') {
            location.href = `${pub.config.pcPassport}zh-cn/changeagentinfo/`;
          } else if (pub.getLang() === 'en-us') {
            location.href = `${pub.config.pcPassport}en-us/changeagentinfo/`;
          } else {
            location.href = `${pub.config.pcPassport}changeagentinfo/`;
          }
        }
      }
    },
    deleteUser() {
      this.isAgentInformation = 2;
    },
    confirmDelte() {
      this.numFlag++
      if (this.numFlag === 1) {
        this.numFlag = 0;
        window.location.href = `https://wa.me/85257266308?text=${lang.whatsappText}`;
      }

    }
  },
};
</script>
<style lang="scss" scoped>
/deep/.van-dialog{
  border-radius: 10px;
  .van-dialog__message--has-title{
    color:#333333;
  }
}
.login_case{
    width: 22%;
      .login_content {
        padding: 20px 0 20px 0; 
        line-height: 24px;
        font-size: 16px;
        color: #333;
        width: 36px;
      }
      .loading{
        top: 35%;
        left: 71%;
        width: 30px !important;
        height: 30px !important;
      }
  }
.fcolor {
    color: #666 !important;
  }
 .agentcontent {
    display: flex;
    justify-content: flex-end;
    padding-top:30px;
    .spanCont{
      display:inline-block;
      height :20px
    }
  }
span.red {
  color: #ed1818;
  font-size: 15px;
  font-weight: 700;
}
.van-field {
  /deep/.van-field__label {
    max-width: 140px;
  }
}
.van-nav-bar {
  border-bottom: 1px solid #e3e4e6;
  background-color: #fafbfc;
}
.van-nav-bar__title {
  font-size: 17px;
  font-weight: bold;
}
.van-nav-bar__text {
  color: #333;
}
.van-nav-bar .van-icon {
  font-size: 25px;
  color: black;
}
.edit-user {
  height: 100%;
  background-color: #f5f6f7;
  font-size: 15px;
  color: #333;
  .nav-edit {
    .van-nav-bar__right {
      .van-nav-bar__text {
        color: #0076ff;
      }
    }
  }

  /deep/.van-uploader__input {
    width: 95%;
  }
  /deep/.edit-up-pic {
    width: 100%;
    height: 100%;
    .avatar-cropper-container {
      overflow: hidden;
      position: relative;
      width: 80%;
      padding-top: 80%;
      margin: 32px auto;
      .width-height {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
    .btn-edit-pic {
      .van-button {
        margin: 0 16px;
        width: 120px;
        background-color: #fff;
        border: none;
        height: 44px;
        line-height: 44px;
        color: #333;
        font-size: 15px;
      }
      .cancel {
        border: 1px solid #b2b2b2;
        color: #1989fa;
      }
      .comfrim {
        background-color: #ed1c24;
        border: 1px solid #f44;
        color: #fff;
      }
    }
  }
  /*弹出框 */
  /deep/.van-popup.van-popup--bottom.edit-pic {
    background-color: transparent;
    .new-img-uploader {
      .up-img-input {
        display: none;
      }
    }
    .uploader {
      width: 100%;
    }
    .van-button {
      background-color: #fff;
      border: none;
      height: 50px;
      line-height: 50px;
      color: #333;
      font-size: 15px;
      &.choose {
        border-radius: 10px 10px 0 0;
        border-bottom: 1px solid #eee;
      }
      &.remove {
        border-radius: 0 0 10px 10px;
      }
      &.cancel {
        border-radius: 10px;
        margin: 10px 0 1px 0;
      }
    }
  }
  /**弹出框 修改会员名称 */
  /deep/ .van-dialog.edit-user-name {
    .van-dialog__content {
      padding: 16px;
      .van-cell.van-field {
        box-sizing: border-box;
        border: 1px solid #eee;
        .van-field__body input {
          &::placeholder {
            font-size: 12px;
          }
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          word-wrap: break-word;
        }
      }
    }
  }
  /deep/ .van-dialog.edit-email-notice {
    .van-dialog__content {
      padding: 24px 16px;
      font-size: 15px;
      color: #666;
      p {
        line-height: 24px;
      }
    }
  }
  .user-img.van-cell {
    margin-top: 16px;
    height: 90px;
    line-height: 70px;
    .van-cell__title {
      text-align: left;
    }
    .van-cell__value {
      position: relative;
      img {
        //图片背景
        background-image: url('//static.house730.com/m/images/user-default.png');
        background-size: 40px 40px;
        top: 10px;
        right: 30px;
        position: absolute;
        height: 50px;
        width: 50px;
        border-radius: 2px;
        background-color: #ccc;
      }
      .van-icon-arrow {
        color: #b2b2b2;
        font-size: 14px;
      }
    }
  }
  .user-detail {
    .switch-select {
      /deep/ .van-cell__value {
        width: 65px;
      }
      /deep/ .van-cell__title {
        width: calc(100% - 65px);
        text-align: left;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    /deep/ .van-icon-arrow {
      font-size: 14px;
      color: #b2b2b2;
    }
    /deep/ .van-cell {
      &.no-password {
        .van-cell__value {
          color: #0076ff;
        }
      }
      .van-cell__title {
        flex: none !important;
        margin-right: 12px;
        font-size: 15px;
        color: #333;
      }
      .van-cell__value {
        color: #666;
        font-size: 15px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .agency {
    .show-detail {
      .user-card {
        width: 100%;
        height: 120px;
        background: url('./../assets/user-agent-bg.png') center;
        background-size: 100% 100%;
        display: flex;
        padding: 24px 36px 0;
        box-sizing: border-box;
        .user-pic {
          width: 70px;
          height: 70px;
          background-color: #eee;
          margin-right: 16px;
          img {
            width: 100%;
            height: 100%;
            overflow: hidden;
            border-radius: 2px;
          }
        }
        .user-card-detail {
          width: calc(100% - 86px);
          color: #fff;
          font-size: 12px;
          line-height: 18px;
          div {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .user-name {
            margin-top: 4px;
            font-size: 17px;
            line-height: 24px;
          }
        }
      }
      .user-license {
        padding: 13px 17px;
        background: #f5f6f8;
        font-size: 12px;
        line-height: 16px;
        color: #666;
        border-radius: 0px 0px 24px 24px;
      }
      .agent-detail {
        .van-cell .van-cell__title {
          line-height: 21px;
          font-size: 15px;
          span {
            color: #999;
          }
          .van-cell__label {
            color: #333;
          }
        }
        .company-img.van-cell {
          margin-bottom: 16px;
          // height: 115px;
          line-height: 95px;
          .van-cell__title {
            text-align: left;
            color: #999;
            padding-top: 2px;
            // line-height: 95px;
          }
          .van-cell__value {
            position: relative;
            img {
              background-image: url('//static.house730.com/m/images/none_img.png');
              background-size: 100px 75px;
              top: 10px;
              right: 30px;
              position: absolute;
              height: 75px;
              width: 100px;
              border-radius: 2px;
              background-color: #ccc;
            }
            .van-icon-arrow {
              color: #b2b2b2;
              font-size: 14px;
            }
          }
        }
      }
    }
    .edit-detail {
      .van-cell.van-field {
        padding-top: 0;
        /deep/.van-field__control {
          color: #666;
        }
      }
      .input-title {
        padding: 15px 15px 10px;
        // span.red {
        //   color: #ed1818;
        //   font-size: 15px;
        //   font-weight: 700;
        // }
      }
      .textarea {
        padding: 5px 15px 10px;
        border-bottom: 1px solid #eee;
        position: relative;
        textarea {
          line-height: 24px;
          background-color: #fff;
          padding: 0;
          width: 100%;
          height: 140px;
          border: none;
          resize: none;
          color: #666;
        }
        .textarea-num {
          position: absolute;
          right: 15px;
          bottom: 10px;
          font-size: 13px;
          color: #b2b2b2;
        }
      }
      .div-line {
        width: 100%;
        height: 12px;
        background: #f5f6f7;
        box-shadow: 0px -1px 0px 0px #e6e6e6;
      }
      .agent-pic {
        border-bottom: 1px solid #eee;
        // span.red {
        //   color: #ed1818;
        //   font-size: 15px;
        //   font-weight: 700;
        // }
        .van-cell {
          // height: 130px;
          line-height: 85px;
          .van-cell__value {
            img {
              width: 100px;
              height: 75px;
            }
          }
          .van-cell__title {
            line-height: 20px;
            margin-top: 2px;
            div {
              line-height: 22px;
              font-size: 15px;
              color: #333;
            }
            p {
              font-size: 11px;
              line-height: 14px;
              color: #ed1818;
              // display: -webkit-box;
              // -webkit-line-clamp: 2;
              // overflow: hidden;
              // text-overflow: ellipsis;
              // -webkit-box-orient: vertical;
            }
          }
          .up-agent-input {
            display: none;
          }
          .img-bg {
            margin-right: 12px;
            position: relative;
            top: -2px;
            display: inline-block;
            width: 100px;
            height: 75px;
            background: url('./../assets/agent-bg.png');
            background-size: 100% 100%;
            vertical-align: middle;
          }
        }
      }
    }
    text-align: left;
    background-color: #fff;
    .van-switch-cell {
      margin-bottom: 16px;
    }
    .agency-title {
      font-weight: 700;
    }
    .notice {
      color: #ed1c24;
      font-size: 12px;
      padding: 16px 22px 0;
    }
    .btn-sub {
      padding: 0 16px;
    }
    .van-uploader {
      width: 100%;

      .van-uploader {
        width: 100%;
      }
      .van-cell {
        // height: 72px;
        line-height: 52px;
        .van-cell__title {
          text-align: left;
        }
        .van-cell__value {
          position: relative;
          img {
            //图片背景
            background-size: 100% 100%;
            top: 6px;
            right: 30px;
            position: absolute;
            height: 40px;
            width: 40px;
            background-color: #ccc;
          }
        }
      }
    }
  }
  .third-party{
    padding: 10px;
    padding-left: 15px;
    background-color: #fff;
    .third-tit{
      text-align: left;
      margin:15px 0;
      color: #333333;
    }
    .social-btn{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .bind-txt{
        cursor: pointer;
        color: #106FC4;
        text-decoration: underline;
      }
    }
    .facebook-redirect-btn{
      margin-top: 10px;
    }
    .social-icon{
      width: 20px;
    }
  }
  .agent-card {
    width: 100%;
  }
  .user .agent {
    margin-top: 20px;
    text-align: left;
  }
}
.delete-user {
  padding-left: 15px;
  text-align: left;
  margin-top: 20px;
  font-family: PingFangTC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
}
.delete-page {
  padding: 0 16px;
  .confirm-delete {
    height: 44px;
    background: #e70e1a;
    border-radius: 4px;
    line-height: 44px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 17px;
    color: #ffffff;
  }
  .delete-page-title {
    font-family: PingFangTC-Semibold;
    font-weight: bold;
    font-size: 16px;
    color: #333333;
    margin: 24px auto;
  }
  .delete-page-info {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    text-align: left;
    line-height: 20px;
  }
}
.company-tips {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #ed1818;
  line-height: 16px;
  margin-top: 6px;
}
</style>
